require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/fn/object/set-prototype-of.js
// module id = 598
// module chunks = 168707334958949